import React, { Component } from "react";
import { Route, Routes } from "react-router";
import { legacy_connect as connect } from "react-redux";
import ReactGA from "react-ga4";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { isEqual } from "lodash";
import * as queryString from "query-string";
import { withTranslation } from "react-i18next";
//TO REMOVE

import { ClientJS } from "clientjs";

import Exit from "containers/Exit";
import Error from "containers/Error";
import Content from "containers/Content";
import Categories from "containers/Categories";
import Navigation from "containers/Navigation";
import GameNavigation from "containers/GameNavigation";
import Games from "containers/Games";
import Update from "containers/Update";
import Menu from "containers/Menu";
import BetHistory from "containers/BetHistory";
import Search from "containers/Search";
import History from "containers/History";
import RoundHistoryPerGame from "containers/RoundHistoryPerGame";
import GameRoundResult from "containers/GameRoundResult";
import ShowMore from "containers/ShowMore";
import TournamentViewDetailsDesktop from "containers/TournamentViewDetailsDesktop";
import TournamentLeaderboard from "containers/TournamentLeaderboard";
import JackpotDetails from "containers/JackpotDetails";
import JackpotViewDetails from "containers/JackpotViewDetails";
import GameAction from "containers/GameAction";
import GameActionCollapse from "containers/GameActionCollapse";
import FreeRounds from "containers/FreeRounds";

import "containers/Application/styles.scss";
import { getCookie } from "utils/cookie";
import ShowMoreDesktop from "containers/ShowMoreDesktop";
import { fromJS } from "immutable";
import { GamesLayoutType } from "component/menu/GamesLayout";
import scrollLock from "utils/scrollLock";
import withRouterCompat from "utils/withRouterCompat";

const WrappedNavigation = withRouterCompat(Navigation);
const WrappedGameNavigation = withRouterCompat(GameNavigation);
const WrappedContent = withRouterCompat(Content);
const WrappedCategories = withRouterCompat(Categories);
const WrappedSearch = withRouterCompat(Search);
const WrappedShowMore = withRouterCompat(ShowMore);
const WrappedShowMoreDesktop = withRouterCompat(ShowMoreDesktop);
const WrappedGames = withRouterCompat(Games);
const WrappedTournamentViewDetailsDesktop = withRouterCompat(
  TournamentViewDetailsDesktop,
);
const WrappedFreeRounds = withRouterCompat(FreeRounds);
const WrappedTournamentLeaderboard = withRouterCompat(TournamentLeaderboard);
const WrappedJackpotDetails = withRouterCompat(JackpotDetails);
const WrappedJackpotViewDetails = withRouterCompat(JackpotViewDetails);
const WrappedGameAction = withRouterCompat(GameAction);
const WrappedGameActionCollapse = withRouterCompat(GameActionCollapse);
const WrappedMenu = withRouterCompat(Menu);
const WrappedHistory = withRouterCompat(History);
const WrappedRoundHistoryPerGame = withRouterCompat(RoundHistoryPerGame);
const WrappedGameRoundResult = withRouterCompat(GameRoundResult);
const WrappedBetHistory = withRouterCompat(BetHistory);
const WrappedUpdate = withRouterCompat(Update);
const WrappedExit = withRouterCompat(Exit);

class App extends Component {
  constructor(props) {
    super(props);
    this.onWindowResize = this._onWindowResize.bind(this);
    this.mainContentRef = React.createRef();
    this.state = {
      noPath: false,
      scrollY: 0,
    };
  }

  _onWindowResize() {
    let height =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,
      width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

    this.props.setWindowSize({
      height,
      width,
    });
  }

  async supportsAVIF() {
    return new Promise((resolve) => {
      var avif = new Image();
      avif.src =
        "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";
      avif.onload = () => {
        resolve(true);
      };
      avif.onerror = () => {
        resolve(false);
      };
    });
  }

  async supportsWebp() {
    return new Promise((resolve) => {
      var webp = new Image();
      webp.src =
        "data:image/webp;base64,UklGRiIAAABXRUJQVlA4TAYAAAAvAAAAAAfQ//73v/+BiOh/AAA=";
      webp.onload = () => {
        resolve(true);
      };
      webp.onerror = () => {
        resolve(false);
      };
    });
  }

  async componentDidMount() {
    if (!this.props.pages) {
      scrollLock.lock(this.mainContentRef.current);
    }

    const isAvifSupported = await this.supportsAVIF();
    const isWebpSupported = await this.supportsAVIF();
    let imageFormat = {
      banner: "jpeg",
      icon: "png",
      gamelobbyBanner: "jpeg",
      tournaments: "jpeg",
      providers: "jpeg",
    };

    if (isAvifSupported) {
      imageFormat.banner = "avif";
      imageFormat.icon = "avif";
      imageFormat.gamelobbyBanner = "avif";
      imageFormat.tournaments = "avif";
      imageFormat.logoRound = "avif";
      imageFormat.providers = "avif";
    } else if (isWebpSupported) {
      imageFormat.banner = "webp";
      imageFormat.icon = "webp";
      imageFormat.gamelobbyBanner = "webp";
      imageFormat.tournaments = "webp";
      imageFormat.logoRound = "webp";
      imageFormat.providers = "webp";
    }

    if (this.props.hasModalLaunched) {
      document.getElementById("root").classList.add("has-modal");
      document.body.classList.add("has-modal");
    } else {
      document.getElementById("root").classList.remove("has-modal");
      document.body.classList.remove("has-modal");
    }

    this.onWindowResize();

    window.addEventListener("resize", this.onWindowResize);
    if (this.props.match.path === "/") {
      this.setState({
        noPath: true,
      });
    }

    //eslint-disable-next-line
    let client = new ClientJS();
    //let nameArr = [client.getBrowserData().os.name.toLowerCase(), client.getBrowserData().browser.name.toLowerCase()];

    if (client.getBrowserData().os.name.toLowerCase() === "android") {
      document.documentElement.classList.add("android");
    }

    let { params } = this.props.match;

    let hideSplash = undefined;
    let showMenu = undefined;
    let appId;

    if (this.props.location.search) {
      let urlParams = new URLSearchParams(this.props.location.search);
      hideSplash = urlParams.get("hideSplash")
        ? urlParams.get("hideSplash") === "true"
        : undefined;
      showMenu = urlParams.get("showMenu")
        ? urlParams.get("showMenu") === "true"
        : undefined;
      appId = urlParams.get("appId");
    }

    let inIframe = () => {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    };
    var isTouch = "ontouchstart" in document.documentElement;
    let browserProps = {
      browser: navigator.userAgent,
      isMobile:
        client.isMobile() || client.getBrowser() === "Mobile Safari" || isTouch,
      isMobileIOS: client.isMobileIOS(),
      hideSplash,
      showMenu,
      appId,
      inIframe: inIframe(),
      imageFormat: fromJS(imageFormat),
    };
    let srvcred = getCookie("srvcred");
    srvcred = srvcred === "" ? {} : JSON.parse(srvcred);

    if (!srvcred[params.sessionId]) {
      srvcred[params.sessionId] = {
        dateCreated: new Date(),
        uuid: null,
        gs: null,
      };
    }

    let cookieProps = {
      sessionId: params.sessionId,
      hideSplash,
      showMenu,
      srvcred: JSON.stringify(srvcred),
    };

    let { uuid, gs } = srvcred[params.sessionId];
    params.uuid = uuid;
    params.gs = gs;

    this.props.setBrowser(browserProps);
    this.props.initApp(params);
    this.props.setCookie(cookieProps);

    if (window.APP_ENV) {
      console.log("APP_ENV", window.APP_ENV);
      let measurementId;

      switch (window.APP_ENV) {
        case "production": //prod
          measurementId = "G-0WSCKQDVMJ";
          break;
        default:
          //int and dev
          measurementId = "G-YLRXB8S8G1";
          break;
      }

      ReactGA.initialize(measurementId, { debug: true });
    }

    this.handleHistoryManagement();
  }

  componentWillUnmount() {
    scrollLock.unlock(this.mainContentRef.current);
    window.removeEventListener("resize", this.onWindowResize);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.pages && nextProps.pages) {
      scrollLock.unlock(this.mainContentRef.current);
    }

    if (this.props.pages && !nextProps.pages) {
      scrollLock.lock(this.mainContentRef.current);
    }

    if (nextProps.hasModalLaunched !== this.props.hasModalLaunched) {
      if (nextProps.hasModalLaunched) {
        document.getElementById("root").classList.add("has-modal");
        document.body.classList.add("has-modal");
      } else {
        document.getElementById("root").classList.remove("has-modal");
        document.body.classList.remove("has-modal");
      }
    }

    if (nextProps.locale !== this.props.locale && nextProps.locale) {
      this.props.i18n.changeLanguage(nextProps.locale);
    }

    if (nextProps.appEnv !== this.props.appEnv && nextProps.appEnv) {
      console.log("appEnv:", nextProps.appEnv);
      let measurementId;

      switch (nextProps.appEnv) {
        case "production": //prod
          measurementId = "G-0WSCKQDVMJ";
          break;
        default:
          //int and dev
          measurementId = "G-YLRXB8S8G1";
          break;
      }

      ReactGA.initialize(measurementId);
    }

    if (nextProps.mode && nextProps.mode !== this.props.mode) {
      ReactGA.event({
        action: "load_app",
        category: nextProps.mode,
      });
    }

    if (
      nextProps.getBalance &&
      nextProps.getBalance !== this.props.getBalance
    ) {
      this.props.fetchBalance();
    }

    if (nextProps.getPages && nextProps.getPages !== this.props.getPages) {
      this.props.wlFetchPages();
    }

    if (
      nextProps.notificationUrl &&
      nextProps.notificationUrl !== this.props.notificationUrl
    ) {
      this.props.initServerSent(nextProps.notificationUrl);
    }

    if (nextProps.wlProfile && nextProps.wlProfile !== this.props.wlProfile) {
      this.props.wlFetchProfile();
    }

    if (nextProps.sessionId && nextProps.sessionId !== this.props.sessionId) {
      //TODO: Remove when theme is ready
      /* this.props
        .fetchTheme()
        .then((response) => {
          return this.props.setTheme(response);
        })
        .catch((err) => {
          return this.props.setTheme(null);
        }); */

      this.props
        .fetchLinks()
        .then((response) => {
          let { gs, uuid } = response;
          let payload = {
            gs,
            uuid,
          };
          this.props.setCookie(payload);
          return response;
        })
        .then((response) => {
          return this.props.setLinks(response);
        });
    }

    if (nextProps.modals && nextProps.modals !== this.props.modals) {
      if (nextProps.modals.size > 0) {
        let scrollY = window.pageYOffset;
        this.setState({
          scrollY: scrollY,
        });
      } else {
        window.scrollTo(0, this.state.scrollY);
      }
    }

    if (isEqual(nextProps.location, this.props.location)) {
      let search = queryString.parse(nextProps.location.search);
      if (search.nav && search.playType) {
        if (search.gameId) {
          ReactGA.event({
            category: search.nav,
            action: search.playType,
            label: search.gameId,
          });
          if (search.q) {
            ReactGA.event({
              action: "launch_on_search",
              category: search.nav,
              label: search.q,
            });
          }
        }
        if (search.gameActionId) {
          ReactGA.event({
            category: search.nav,
            action: search.playType,
            label: search.gameActionId,
          });
          if (search.q) {
            ReactGA.event({
              action: "launch_on_search",
              category: search.nav,
              label: search.q,
            });
          }
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.key !== prevProps.location.key) {
      this.handleHistoryManagement();
    }

    if (this.props.pages && !isEqual(this.props.pages, prevProps.pages)) {
      let newLoc = this.props.location.pathname;

      if (this.props.match.url === this.props.location.pathname) {
        let { locale, sessionId, page, category } = this.props.match.params;

        let myQT = this.props.pages.get("wl-pages").find((page) => {
          return page.get("rel") === "myQT";
        });
        let webMainLobby = this.props.pages.get("wl-pages").find((page) => {
          return page.get("rel") === "webLobbyMain";
        });
        let initPage = webMainLobby.getIn(["content", 0]);

        if (myQT) {
          newLoc = `/${locale}/${sessionId}/categories/${myQT.get("rel")}`;
        } else if (!page || !category) {
          newLoc = `/${locale}/${sessionId}/games/${initPage.get(
            "rel",
          )}/${initPage
            .getIn(["links"])
            .find((link) => link.get("rel").indexOf("games") > -1)
            .get("rel")}`;
        }
      }

      if (this.props.gameId) {
        let games = fromJS([null, null, null, null]);
        let gameParam = new URLSearchParams();
        gameParam.gameId = this.props.gameId;
        if (this.props.playType) gameParam.playType = this.props.playType;
        if (this.props.nav) gameParam.nav = this.props.nav;

        games = games.setIn([0], gameParam);

        let gamesEnc = btoa(encodeURIComponent(JSON.stringify(games.toJSON())));

        let params = {
          games: gamesEnc,
          layout: GamesLayoutType.LAYOUT_1,
        };

        newLoc = `${newLoc}?${queryString.stringify(params)}`;
      } else {
        newLoc = `${newLoc}${this.props.location.search}`;
      }

      if (newLoc !== this.props.match.url) {
        this.props.navigateTo(newLoc);
      }
    }
  }

  handleHistoryManagement = () => {
    /* const { location, match, history } = this.props;
    const { locale, sessionId } = match.params;

    const isBlankLobbyPage =
      location.pathname === `/${locale}/${sessionId}` ||
      location.pathname === `/${locale}/${sessionId}/`;

    if (isBlankLobbyPage) {
      setTimeout(() => {
        history.replace(`/${locale}/${sessionId}/categories/myQT`);
      }, 0);
    } */
  };

  render() {
    return (
      <div
        className="container-fluid application nopadding"
        style={this.props.theme ? this.props.theme.toJSON() : {}}
      >
        <>
          <div ref={this.mainContentRef} className="main-content d-flex flex-column">
            <Routes>
              <Route path="games/:page/*" element={<WrappedNavigation />} />
              <Route
                path="categories/:page/*"
                element={<WrappedNavigation />}
              />
            </Routes>
            <Routes>
              <Route
                path="games/:page/*"
                element={<WrappedGameNavigation />}
              />
              <Route
                path="categories/:page/*"
                element={<WrappedGameNavigation />}
              />
            </Routes>
            <Routes>
              <Route
                path="games/:page/:category/*"
                element={<WrappedContent />}
              />
              <Route
                path="categories/:page/*"
                element={<WrappedCategories />}
              />
            </Routes>
            <Routes>
              <Route path="*" element={<WrappedSearch />} />
            </Routes>
            <Routes>
              <Route
                path="*"
                element={
                  this.props.isMobile ? (
                    <WrappedShowMore />
                  ) : (
                    <WrappedShowMoreDesktop />
                  )
                }
              />
            </Routes>
            <Routes>
              <Route path="*" element={<WrappedGames />} />
            </Routes>
            <Routes>
              <Route
                path="*"
                element={<WrappedTournamentViewDetailsDesktop />}
              />
            </Routes>
            <Routes>
              <Route path="*" element={<WrappedFreeRounds />} />
            </Routes>
            <Routes>
              <Route
                path="*"
                element={<WrappedTournamentLeaderboard />}
              />
            </Routes>
            <Routes>
              <Route path="*" element={<WrappedJackpotDetails />} />
            </Routes>
            <Routes>
              <Route
                path="*"
                element={<WrappedJackpotViewDetails />}
              />
            </Routes>
            <Routes>
              <Route path="*" element={<WrappedGameAction />} />
            </Routes>
            <Routes>
              <Route
                path="*"
                element={<WrappedGameActionCollapse />}
              />
            </Routes>
            <Routes>
              <Route path="*" element={<WrappedMenu />} />
            </Routes>
            <Routes>
              <Route path="*" element={<WrappedHistory />} />
            </Routes>
            <Routes>
              <Route
                path="*"
                element={<WrappedRoundHistoryPerGame />}
              />
            </Routes>
            <Routes>
              <Route
                path="*"
                element={<WrappedGameRoundResult />}
              />
            </Routes>
            <Routes>
              <Route path="*" element={<WrappedBetHistory />} />
            </Routes>
            <Error />
            <Routes>
              <Route path="*" element={<WrappedUpdate />} />
            </Routes>
            <Routes>
              <Route path="exit/*" element={<WrappedExit />} />
            </Routes>
            <div className="d-none" />
          </div>
        </>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let {
    games,
    showMore,
    modalRel,
    showTournamentDetails,
    route,
    showJackpotDetails,
    gameId,
    playType,
  } = queryString.parse(window.location.search);
  let hasGameAction = state.game.get("params");
  let showMenu = state.application.get("showMenu");

  let hasModalLaunched =
    games ||
    showMore ||
    modalRel ||
    hasGameAction ||
    showTournamentDetails ||
    route ||
    showJackpotDetails ||
    showMenu;

  return {
    gameId,
    playType,
    hasModalLaunched,
    getBalance: state.links.get("getBalance"),
    getPages: state.links.get("getPages"),
    notificationUrl: state.links.getIn(["notificationUrls", 0]),
    wlProfile: state.links.get("wl.profile"),
    skin: state.links.get("skin"),
    isMobile: state.window.get("isMobile"),
    filtersVisible: state.config.get("filtersVisible"),
    sizeSuffix: state.window.get("sizeSuffix"),
    locale: state.config.getIn(["locale"]),
    configRoute: state.config.get("route"),
    mode: state.links.get("mode"),
    urls: state.urls,
    loginUrl: state.urls
      ? state.urls.getIn(["loginUrls", state.config.get("currentLoginIndex")])
      : null,
    username: state.user.get("username"),
    sessionId: state.security.get("sessionId"),
    pages: state.pages,
    modals: state.window.get("modals"),
    appEnv: window.APP_ENV,
    theme: state.theme,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    login: (username, password) => dispatchProps.login(username, password),
    logout: () => dispatchProps.logout(),
    navigateTo: (path) => ownProps.history.push(path),
    restoreState: () => dispatchProps.restoreState(),
    wlFetchPages: () => dispatchProps.wlFetchPages(),
    setWindowSize: (size) => dispatchProps.setWindowSize(size),
    setWindowScroll: (props) => dispatchProps.setWindowScroll(props),
    initApp: (params) => dispatchProps.initApp(params),
    setBrowser: (props) => dispatchProps.setBrowser(props),
    fetchLinks: () => dispatchProps.fetchLinks(),
    setLinks: (data) => dispatchProps.setLinks(data),
    fetchBalance: () => dispatchProps.fetchBalance(),
    wlFetchProfile: () => dispatchProps.wlFetchProfile(),
    setCookie: (params) => dispatchProps.setCookie(params),
    initServerSent: (route) => dispatchProps.initServerSent(route),
    onGameClose: (params) => dispatchProps.onGameClose(params),
    fetchTheme: () => dispatchProps.fetchTheme(),
    setTheme: (data) => dispatchProps.setTheme(data),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(withTranslation("translation")(App));
